import { z } from 'zod';

export enum BMSSampleDecision {
  BROUGHT = 'BROUGHT',
  NOT_BRINGING = 'NOT_BRINGING',
  BRING_LATER = 'BRING_LATER',
}

// amount the participant is asked to hand in, taken from their cohort
export const DEFAULT_BMS_SAMPLE_GRAMS = 1;

export const userBmsSampleResDto = z.object({
  surveyLink: z.string(),
  bmsId: z.string(),
  broughtAt: z.coerce.date().nullable(),
  decidedNotToBringAt: z.coerce.date().nullable(),
  sampleGrams: z.number(),
});
export type UserBmsSampleResDto = z.infer<typeof userBmsSampleResDto>;

export const setBmsSampleDecisionReqDto = z.object({
  decision: z.enum(BMSSampleDecision),
});
export type SetBmsSampleDecisionReqDto = z.infer<
  typeof setBmsSampleDecisionReqDto
>;
